import Button from '@/features/shared/Button';
import Image from '@/features/shared/Image';
import { MuiTypography } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import SmallCTA from '../SmallCTA';
import { SquareTileSquareContent } from '../SquareTileCTA.interface';
import useStyles from './SquareCTA.styles';

const SquareCTA = ({ theme = Theme.light, content = {} }: Partial<SquareTileSquareContent>) => {
  const classes = useStyles({});
  const rootClasses = clsx(classes.root, `${theme}-theme`);
  const muiTheme = useTheme();
  const shouldDisplaySmallCTA = useMediaQuery(muiTheme.breakpoints.down('sm'));

  const { image, title, link } = content;
  const smallCtaContent = {
    ...(image && { image }),
    ...(title && { label: title }),
    ...(link?.href && { link: link.href }),
    theme,
  };

  return (
    <>
      {shouldDisplaySmallCTA ? (
        <SmallCTA theme={theme} content={smallCtaContent} />
      ) : (
        <div className={rootClasses} data-testid="qa-square-cta-component">
          {content?.image ? (
            <div className={classes.img} data-testid="qa-square-cta-component-image">
              <Image image={content?.image} base="original" size="contain" position="center" />
            </div>
          ) : (
            content.title && (
              <MuiTypography
                variant="h6"
                component="div"
                className={classes.description}
                data-testid="qa-square-cta-component-title"
              >
                {content.title}
              </MuiTypography>
            )
          )}
          {content.description && (
            <MuiTypography
              variant="body1"
              component="div"
              className={classes.description}
              data-testid="qa-square-cta-component-description"
            >
              {content.description}
            </MuiTypography>
          )}
          {content.link && (
            <Button
              theme={theme}
              outlined
              link={content.link}
              data-testid="qa-square-cta-component-link"
            />
          )}
        </div>
      )}
    </>
  );
};

export default SquareCTA;
